module.exports = __webpack_public_path__ + "photo.cdd99f6b.png";